import React from 'react'
import { withRouteData, Head } from 'react-static'
import Markdown from 'react-markdown'
import { Link } from '@reach/router'

const Gallery = ({ galleryData }) => {
  return (
    <React.Fragment>
      <Head key="page-head">
        <title>Pineview Builders | Gallery</title>
        <meta name="description" content="The Pineview Builders gallery of homes" />
      </Head>
      <div className='page-content'>
        {galleryData.sort((gallery1, gallery2) =>
          gallery1.data.order - gallery2.data.order
        ).map(gallery =>
          <Link to={`/gallery/${gallery.data.slug}/`} key={gallery.data.slug}>
            <h1>{gallery.data.galleryTitle}</h1>
            <img src={gallery.data.featuredImage} alt={`Featured image for ${gallery.data.galleryTitle} home`} />
          </Link>
        )}
      </div>
    </React.Fragment>
  )
}

export default withRouteData(Gallery)
